var activeElements = unescape(Cookies.get("actElems"));
if (activeElements == "null") {
	activeElements = "";
}
var today = new Date();
var expire = new Date();

document.ready = function () {

}

function nastavZobrazeniFormulare(elem, elemId, language) {
	var checkedElem = false;
	if ($(elem).is(':checked')) {
		checkedElem = true;
	}

	$('.registrace-form').find(':checked').each(function (idx) {
		$(this).prop('checked', null);

	});

	if (checkedElem) {
		$(elem).prop('checked', 'checked');
	}

	if (language == 'huXXXX') {
		alert('Kedves Ügyfelek! A Generali logós reklám és ajándéktárgyak rendelésének lehetősége jelenleg szünetel. A webáruház újranyitásáról a Generali Biztosító Zrt. az érintetteket értesíteni fogja. Tisztelettel: Az Excursion Services Kft.');
		$(elem).prop('checked', null);
		return false;
	}

	zmenBlok(elem, elemId);
	prepniRegistracniFormular(elem.id);
}

function zmenBlok(elem, elemId) {
	var elemBlok = document.getElementById(elemId);
	if (elem.checked == true) {
		elemBlok.className = null;
	} else {
		elemBlok.className = "old";
	}
}

function prepniRegistracniFormular(id) {
	$('.registrace-formular').each(function (idx) {
		//$(this).addClass('old');
		$(this).hide();
	});

	//$('#' + id + '-form').removeClass('old');
	$('#' + id + '-form').show();
}


function zobrazHarmonogramRozvozu(elem) {
	var url = "/custom/zavozovy-harmonogram/?oblast=";

	var prov = $('#id_provozov').val();
	var obl = seznamAdres[prov].id_oblasti;

	$(elem).attr('href', url + obl);

	return hs.htmlExpand(elem, {
		objectType: 'ajax',
		contentId: 'ajaxContent',
		align: 'center',
		width: '350',
		height: '560',
		cacheAjax: false,
		preserveContent: false
	});
}

function kontrolaZadostiVygenerovatNoveHeslo() {
	var email = $('#email').val();
	if (email.length < 3) {
		alert(hlaseniEmail);
		return false;
	}
}

function prenactiStatVRegistraci() {
	$('#id_staty').trigger('onchange');
	//$('#id_staty').trigger('click');
}

function registraceZmenStat(id_statu) {

	if (id_statu != "0") {

		if (id_statu == "HU") {
			$('#regFormHungary').removeClass('old');
			getWebURL('/index.php?tName=indexclear;io=custom;subio=nactiVyberDodacichAdres;id_staty=' + id_statu, 'regFormHungary');
		} else {
			$('#regFormHungary').addClass('old');
		}

		$.get('/index.php?tName=indexclear;io=custom;subio=novyStat;id_staty=' + id_statu, function (data) {
			$('#regFormDivize').html(data);
		});
	}

}

function registraceZmenDivizi(id_divize) {
	var id_statu = $('#id_staty').val();

	if (id_divize != "0") {

		if (id_statu == "HU") {
			$('#regFormHungary').removeClass('old');

			if (id_divize == 69869 || id_divize == 69936 || id_divize == 73361) {
				$('#hungaryFaktAdresa').removeClass('old');
			} else {
				$('#hungaryFaktAdresa').addClass('old');
			}
			getWebURL('/index.php?tName=indexclear;io=custom;subio=nacistDodaciAdresy;id_odberat=' + id_divize, 'regFormHungary');
		} else {
			$('#regFormHungary').addClass('old');
		}

		$.get('/index.php?tName=indexclear;io=custom;subio=novaDivize;id_divize=' + id_divize, function (data) {
			$('#regFormSchvalovatel').html(data);
		});
	}

}

function nactiDodaciAdresu(id_adresy) {
	var id_divize = $('#id_divize').val();

	$.get('/index.php?tName=indexclear;io=custom;subio=nastavDodaciAdresu;id_adresy=' + id_adresy + ';id_divize=' + id_divize, function (data) {
		$('#regFormHungary').html(data);
	});

}

function zkontrolujMobil() {
	var stat = $('#id_staty').val();
	var mobil = $('#mobil').val();
	if (stat == 'HU' && mobil.length > 0) {
		var mobilTester = /^(\+36)[0-9]{2}[0-9]{7}$/i
		if (!mobilTester.test(mobil)) {
			alert('A megadott telefonszám nem felel meg a megengedett formátumnak. Kérem, javítsa ki ezt a tételt. [+36xx1234567]');
			return false;
		}
	}
	if (stat == 'CZ' && mobil.length > 0) {
		var mobilTester = /^(\+420)[0-9]{9}$/i
		if (!mobilTester.test(mobil)) {
			alert('Telefonní číslo zadejte ve tvaru +420xxxxxxxxx');
			return false;
		}
	}
}

function nastavitBudget(msg) {
	if ($('#pocatecni').val() == '') {
		return confirm(msg);
	}

	return true;
}

function kontrolaRegistraceZadanychUdaju(typregistrace) {
	var idUzivateleNCH = $('#telefon').val();
	var datumNastupu = $('#fax').val();
	var ulice = $('#ulice').val();
	var mesto = $('#mesto').val();
	var psc = $('#psc').val();
	var idDivize = $('#id_divize').val();
	var idSchvalovatel = $('#id_schvalovatel').val();
	var id_adresa = $('#id_provozov').val();
	var id_statu = $('#id_staty').val();

	if (typregistrace == 'osoba') {
		if (idDivize == 0) {
			alert(hlaseniDivizeNevybrana);
			return false;
		}

		if (idSchvalovatel == 0) {
			alert(hlaseniSchvalovatelNevybran);
			return false;
		}

		if (id_adresa == "NOT" && id_statu == "HU") {
			alert(hlaseniDodaciAdresaNevybrana);
			return false;
		}

		if (idUzivateleNCH != undefined && (idUzivateleNCH.length == 0 || idUzivateleNCH.length > 20)) {
			alert(hlaseniUdajeIdUzivatele);
			return false;
		}

		if (datumNastupu != undefined && (datumNastupu.length == 0 || datumNastupu.length > 20)) {
			alert(hlaseniUdajeDatumNastupu);
			return false;
		}
	}
	if (ulice.length == 0 || ulice.length > 60) {
		alert(hlaseniUdajeUlice);
		return false;
	}

	if (mesto.length == 0 || mesto.length > 60) {
		alert(hlaseniUdajeMesto);
		return false;
	}

	if (psc.length == 0 || psc.length > 10) {
		alert(hlaseniUdajePSC);
		return false;
	}

	zkontrolujMobil();

	return true;
}

/* function kontrolaRegistraceZadanychUdaju(typregistrace) {
	var idUzivateleNCH = $('#telefon').val();
	var datumNastupu = $('#fax').val();
	var ulice = $('#ulice').val();
	var mesto = $('#mesto').val();
	var psc = $('#psc').val();
	var idDivize = $('#id_divize').val();
	var idSchvalovatel = $('#id_schvalovatel').val();
	var id_adresa = $('#id_provozov').val();
	var id_statu = $('#id_staty').val();

	if (typregistrace == 'osoba') {
		if (idDivize == 0) {
			alert(hlaseniDivizeNevybrana);
			return false;
		}

		if (idSchvalovatel == 0) {
			alert(hlaseniSchvalovatelNevybran);
			return false;
		}

		if (id_adresa == "NOT" && id_statu == "HU") {
			alert(hlaseniDodaciAdresaNevybrana);
			return false;
		}

		if (idUzivateleNCH != undefined && (idUzivateleNCH.length == 0 || idUzivateleNCH.length > 20)) {
			alert(hlaseniUdajeIdUzivatele);
			return false;
		}

		if (datumNastupu != undefined && (datumNastupu.length == 0 || datumNastupu.length > 20)) {
			alert(hlaseniUdajeDatumNastupu);
			return false;
		}
	}
	if (ulice.length == 0 || ulice.length > 60) {
		alert(hlaseniUdajeUlice);
		return false;
	}

	if (mesto.length == 0 || mesto.length > 60) {
		alert(hlaseniUdajeMesto);
		return false;
	}

	if (psc.length == 0 || psc.length > 10) {
		alert(hlaseniUdajePSC);
		return false;
	}

	zkontrolujMobil();

	return true;
} */

function kontrolaZmenaUdaju() {
	var jmeno = $('#osoba_jmeno').val();
	var prijmeni = $('#osoba_prijmeni').val();
	var telefon = $('#osoba_mobil').val();
	var email = $('#email').val();
	var idUzivateleNCH = $('#telefon').val();
	var datumNastupu = $('#fax').val();
	var ulice = $('#ulice').val();
	var mesto = $('#mesto').val();
	var psc = $('#psc').val();

	if (osoba_jmeno.length == 0 || osoba_jmeno.length > 60) {
		alert(hlaseniUdajeJmeno);
		return false;
	}

	if (prijmeni.length == 0 || prijmeni.length > 60) {
		alert(hlaseniUdajePrijemeni);
		return false;
	}

	if (telefon.length == 0 || telefon.length > 20) {
		alert(hlaseniUdajeTelefon);
		return false;
	}

	if (email.length == 0 || email.length > 30) {
		alert(hlaseniUdajeEmail);
		return false;
	}

	if (idUzivateleNCH.length == 0 || idUzivateleNCH.length > 20) {
		alert(hlaseniUdajeIdUzivatele);
		return false;
	}

	if (datumNastupu.length == 0 || datumNastupu.length > 20) {
		alert(hlaseniUdajeDatumNastupu);
		return false;
	}

	if (ulice.length == 0 || ulice.length > 60) {
		alert(hlaseniUdajeUlice);
		return false;
	}

	if (mesto.length == 0 || mesto.length > 60) {
		alert(hlaseniUdajeMesto);
		return false;
	}

	if (psc.length == 0 || psc.length > 10) {
		alert(hlaseniUdajePSC);
		return false;
	}

	return true;
}

function kontrolaReklamacnihoProtokolu() {
	var katCislo = $('#kat_cislo').val();
	var nazev = $('#nazev-zbozi').val();
	var pocetKs = $('#pocet').val();
	var doklad = $('#doklad').val();
	var vada = $('#vada').val();
	var reseni = $('#reseni').val();

	if (katCislo == '') {
		alert(hlaseniReklKatC);
		return false;
	}

	if (nazev == '') {
		alert(hlaseniReklNazev);
		return false;
	}

	if (parseInt(pocetKs) <= 0 || isNaN(pocetKs)) {
		alert(hlaseniReklKS);
		return false;
	}

	if (doklad == '') {
		alert(hlaseniReklDokl);
		return false;
	}

	if (vada.length < 3) {
		alert(hlaseniReklVada);
		return false;
	}

	if (reseni.length < 3) {
		alert(hlaseniReklReseni);
		return false;
	}

	return true;
}

function najdiZbozi(katcislo) {
	$.get('/aio/nazev-zbozi;kat_cislo=' + katcislo, function (data) {
		$('#nazev-zbozi').val(data);
	});
}

function nastavZpusobDoprav(dopr) {
	if (dopr == 'ZAVOZ') {
		$('#terminDodaniZavoz').removeClass('old');
	} else {
		$('#terminDodaniZavoz').addClass('old');
	}
}

function otheradress() {
	obj = document.getElementById('id_provozov');
	i = obj.options[obj.selectedIndex].value;

	upravSeznamDoprav(i);
	var dopr = $('#id_dod_podm').val();

	if (i > 0) {
		if (dopr == 'ZAVOZ') {
			$('#terminDodaniZavoz').removeClass('old');
		} else {
			$('#terminDodaniZavoz').addClass('old');
		}
		$('#terminDodani').html("Načítám informace o termínech ... ");
		$.get('/aio/zavozovy-termin;adresa=' + i, function (data) {
			$('#terminDodani').html(data);
		});
	} else {
		$('#terminDodaniZavoz').addClass('old');
	}

	if (i >= 0) {
		// zobrazit platebni podminky
		$('#podminky').removeClass('old');
	} else {
		// skryt platebni podminky
		$('#podminky').addClass('old');
	}

	if (i == "0") {
		document.getElementById('otheradress').style.display = "";
	} else {
		document.getElementById('otheradress').style.display = "none";
	}
}

function filterDodaciAdresy(fStr) {
	var sbElem = document.getElementById('id_provozov');
	if (isNaN(parseInt(fStr))) {
		return false;
	}

	for (var i = 0; i < sbElem.options.length; i++) {
		var start = sbElem.options[i].text.lastIndexOf('|') + 2;
		if (fStr == sbElem.options[i].text.substr(start, fStr.length)) {
			sbElem.options[i].selected = true;
			break;
		}
	}

	otheradress();
}

function upravSeznamDoprav(i) {
	$('option[value="ZAVOZ"]').removeClass('old').attr('disabled', null).show();

	// upravi seznam doprav
	var dopr = seznamAdres[i];
	if (dopr == undefined || dopr.id_oblasti > 0) {
		return true;
	}

	$('#id_dod_podm option').each(function (i) {
		// projdeme vsechny dopravy
		if ($(this).val() == 'ZAVOZ') {
			// zrusime zavoz
			$(this).hide();
			$(this).removeAttr('selected');
			$(this).attr('disabled', 'disabled');
			$(this).addClass('old');
			$('option[value="CZPOST"]').attr('selected', 'selected');
		}
	});
}

function rozliseniCastky(elem) {
	var castka = $(elem).val();
	var cislo = parseFloat(castka.replace(/,/, '.'));

	if (!isNaN(cislo) && cislo < 0) {
		$(elem).addClass('red');
	} else {
		$(elem).removeClass('red');
	}
}

function dodAdresy(id_adresy, id_oblasti) {
	this.id_adresy = id_adresy;
	this.id_oblasti = id_oblasti;
}

function kontrolaZaskrtnuti() {
	var pocet = $('.cbox:checked').size();
	if (pocet == 0) {
		alert(hlaseniObjCBOX);
		return false;
	} else {
		return true;
	}
}

function prepniObchod(obch) {
	var kosikPocet = parseInt($('#kosikPocet').html());

	var odeslatZmenu = true;
	if (!isNaN(kosikPocet)) {
		odeslatZmenu = confirm(hlaseniPrepniZal);
	}

	if (odeslatZmenu) {
		window.location.href = '/custom/zmena-obchodu/?obchod=' + obch;
	}

	return false;
}

function swCss(elem) {
	if (!elem)
		return false;
	var parElem = elem.parentNode;
	var elemId = parElem.id;
	if (parElem.className == '' || parElem.className == 'liClosed' || parElem.className == 'liBullet') {
		parElem.classList.add('open');
		var stavajiciElem = document.getElementById(activeElements);
		if (stavajiciElem != undefined && stavajiciElem != null) {
			stavajiciElem.classList.remove('open');
		}
		activeElements = elemId;
	}

	expire.setTime(today.getTime() + 3600000 * 24 * -1);
	document.cookie = "actElems" + "=;expires=" + expire.toGMTString();

	expire.setTime(today.getTime() + 3600000 * 24 * 1000);
	document.cookie = "actElems" + "=" + escape(activeElements) + ";expires=" + expire.toGMTString() + "; path=/";

	// elem.blur();
//	return false;
}

function standardniRegistrace() {
	$('#kaizenRegistration').addClass('old');
	$('#kaizenRegistrationBtn').removeClass('regButton').addClass('regButtonNotAct');

	$('#standardRegistration').removeClass('old');
	$('#standardRegistrationBtn').removeClass('regButtonNotAct').addClass('regButton');
}

function kaizenRegistrace() {
	$('#standardRegistration').addClass('old');
	$('#standardRegistrationBtn').removeClass('regButton').addClass('regButtonNotAct');

	$('#kaizenRegistration').removeClass('old');
	$('#kaizenRegistrationBtn').removeClass('regButtonNotAct').addClass('regButton');
}

function registraceJednorazovaStat() {
	var zmenaStat = $('#id-stat').val();

	if (zmenaStat == 0) {
		alert(jednorazovyPristupStatNevybranMsg);
		return false;
	} else {
		document.getElementById('subaction').value = 'gen';
	}

	return true;
}

function RSitem(index, name, code, deep, sub) {
	this.index = index;
	this.name = name;
	this.code = code;
	this.sub = sub;
	this.deep = deep;
}

function publicRSitem() {
	var obj = document.getElementById('cat' + this.deep);
	var oOption = document.createElement("OPTION");
	obj.options [this.index] = null;
	oOption.text = this.name;
	oOption.value = this.index;
	obj.options [obj.options.length] = oOption;
}

function displayRSsubItems() {
	if (this.sub != '') {
		var subs = this.sub.split(',');
		for (var i in subs) {
			items[subs[i]].publicItem();
		}
	}
}

RSitem.prototype.publicItem = publicRSitem;
RSitem.prototype.displaySubItems = displayRSsubItems;

function displayCat(id) {
	var obj = document.getElementById('cat' + id);
	for (var i = id + 1; i <= 3; i++) {
		var panel = document.getElementById('cat' + i);
		if (panel != undefined) {
			for (var j = panel.options.length - 1; j >= 0; j--) {
				panel.options[j] = null;
			}
		}
	}
	for (i = 0; i < obj.options.length; i++) {
		if (obj.options[i].selected == true) {
			items[obj.options[i].value].displaySubItems();
		}
	}
}

function submitCat() {
	var pole = new Array();
	for (var i = 3; i >= 1; i--) {
		var panel = document.getElementById("cat" + i);
		if (panel != undefined) {
			if (panel.selectedIndex != -1) {
				for (var j = 0; j < panel.options.length; j++) {
					if (panel.options[j].selected) {
						pole [pole.length] = items[panel.options[j].value].code;
					}
				}
				document.getElementById('kat').value = pole;
				break;
			}
		}
	}
}

function selectAll(status) {
	if (status) {
		var panel = document.getElementById("cat1");
		for (var j = 0; j < panel.options.length; j++) {
			panel.options[j].selected = true;
		}
		for (var i = 2; i <= 3; i++) {
			var panel = document.getElementById('cat' + i);
			for (var j = panel.options.length - 1; j >= 0; j--) {
				panel.options[j] = null;
			}
		}
	}

	return false;
}

function sellectAllGroup(sbId) {
	var sbElem = document.getElementById(sbId);
	if (sbElem != null) {
		for (var j = 0; j < sbElem.options.length; j++) {
			sbElem.options[j].selected = true;
		}
	}

	return false;
}

function changeTree(newTree) {
	document.getElementById('selTree').className = "old";
	document.getElementById('loadTree').className = "";

	if (newTree == 1) {
		document.getElementById('selTree1').className = "sortiment selTree1";
		document.getElementById('selTree2').className = "selTree";
	} else {
		document.getElementById('selTree1').className = "sortiment selTree";
		document.getElementById('selTree2').className = "selTree1";
	}
	getWebURL('/index.php?tName=indexclear;io=changeTree;newTree=' + newTree, 'shopTree');
}

function closeWindow(winId) {
	document.getElementById(winId).className = "old";
	return false;
}

function newSearchWindow(winId) {
	document.getElementById('searchWindow').className = "win";
	document.getElementById("searchContent1").className = "old";
	document.getElementById("searchContent2").className = "old";
	document.getElementById("searchContent" + winId).className = "";
	return false;
}

function setSearchFilter() {
	var divElemClass = document.getElementById("searchContent1").className;

	var winId = (divElemClass == "old") ? 2 : 1;

	if (winId == 1) {
		// udelame okno 1 - Vyhledavaci skupiny
		var sbArray = new Array('brand', 'ucelp', 'material', 'barva', 'cilskup', 'podtechnol');
		for (var sbKey in sbArray) {
			var setText = '';
			var setValues = '';
			var sbElem = document.getElementById(sbArray[sbKey]);
			if (sbElem != null) {
				if (sbElem.selectedIndex != -1) {
					for (var j = 0; j < sbElem.options.length; j++) {
						if (sbElem.options[j].selected) {
							if (setText.length > 0) {
								setText += '&nbsp;| ';
							}
							setText += sbElem.options[j].text;
						}
					}

					var elemText = document.getElementById(sbArray[sbKey] + 'SearchText');
					if (elemText != null) {
						elemText.innerHTML = setText;
					}
				}
			}
		}
	} else {
		// udelame okno 2 - Stromove kategorie
		for (var i = 3; i >= 1; i--) {
			var panel = document.getElementById("cat" + i);
			if (panel.selectedIndex != -1) {
				var setText = '';
				for (var j = 0; j < panel.options.length; j++) {
					if (panel.options[j].selected) {
						if (setText.length > 0) {
							setText += '&nbsp;| ';
						}
						setText += panel.options[j].text.replace(/ \([0-9]+\)/g, '');
					}
				}

				var elemText = document.getElementById('treeSelected');
				if (elemText != null) {
					elemText.innerHTML = setText;
				}
				break;
			}
		}
	}


	closeWindow('searchWindow');
	return false;
}

function addToBasketKosik(formId, badMsg, skladem, zobrazitHlaseni) {
	var formElem = document.getElementById(formId);
	var kosikCount = formElem.kosik.value;
	var idZbozi = formElem.id_zbozi.value;

	var potisk = '';
	var potisk_ano = 0;

	if (formElem.kosikchecked != null) {
		if (formElem.kosikchecked.checked) {
			potisk_ano = 1;
		}
	}

	if (formElem.kosikpotisk != null) {
		var potisk = formElem.kosikpotisk.value;
	}

	var qty = parseInt(kosikCount);
	if (qty < 0 || isNaN(qty)) {
		alert(badMsg);
		return false;
	}

	if (zobrazitHlaseni == 1) {
		if ((skladem - qty) < 0) {
			alert(nakupDoZaporuMsg);
		}
	}

	return true;
}

function addToBasket(formId, badMsg, skladem, zobrazitHlaseni, reload = false) {
	var formElem = document.getElementById(formId);
	var kosikCount = formElem.kosik.value;
	var idZbozi = formElem.id_zbozi.value;

	var potisk = '';
	var potisk_ano = 0;

	if (formElem.kosikchecked != null) {
		if (formElem.kosikchecked.checked) {
			potisk_ano = 1;
		}
	}

	if (formElem.kosikpotisk != null) {
		var potisk = formElem.kosikpotisk.value;
	}

	var qty = parseInt(kosikCount);
	if (qty < 0 || isNaN(qty)) {
		alert(badMsg);
		return false;
	}

	if (zobrazitHlaseni == 1) {
		if ((skladem - qty) < 0) {
			alert(nakupDoZaporuMsg);
		}
	}

	// getWebURL('/index.php?io=basketChange;tName=indexclear;ajax=1;potisk=' + potisk_ano + ';id_zbozi=' + idZbozi + ';kosik=' + qty + ';kosikpotisk=' + potisk, 'kosikContainer');
	const url = '/index.php?io=basketChange;tName=indexclear;ajax=1;potisk=' + potisk_ano + ';id_zbozi=' + idZbozi + ';kosik=' + qty + ';kosikpotisk=' + potisk;
	const kosikContainer = document.getElementById('kosikContainer');
	fetch(url)
		.then(function (response) {
				if (response.status === 200) {
					addToToastQueue('Zboží přidáno do košíku', 'Zboží bylo úspěšně přidáno do košíku', 'success');
					return response.text();
				} else {
					addToToastQueue('Chyba při vložení do košíku', 'Nepodařilo se přidat zboží do košíku', 'danger');
					console.log(response.statusText);
				}
			}
		)
		.then(function (data) {
			if (kosikContainer) {
				kosikContainer.innerHTML = data;
			}
			if (reload)
					location.reload();
		})
		.catch(function (error) {
			console.log(error);
			addToToastQueue('Chyba při vložení do košíku', 'Nepodařilo se přidat zboží do košíku', 'danger');
		});
	if (qty == 0) {
		formElem.kosik.value = '';
		if (formElem.kosikpotisk != null) {
			formElem.kosikpotisk.value = '';
			formElem.kosikchecked.checked = false;
		}
	}

	return false;
}

function removeFromBasketKosik(idZbozi, reload = false, event) {
	event.preventDefault();
	const url = '/index.php?io=basketRemove;tName=indexclear;ajax=1;id_zbozi=' + idZbozi;
	const rowElement = document.getElementById('kosikRow-' + idZbozi);
	const kosikContainer = document.getElementById('kosikContainer');
	fetch(url)
		.then(function (response) {
			if (response.status === 200) {
				addToToastQueue('Zboží odebráno z košíku', 'Zboží bylo úspěšně odebráno z košíku', 'success');
				rowElement && rowElement.remove();
				return response.text();
			} else {
				addToToastQueue('Chyba při odebrání z košíku', 'Nepodařilo se odebrat zboží z košíku', 'danger');
				console.log(response.statusText);
				setTimeout(function () {
					location.reload();
				}, 5000);
			}
		})
		.then(function (data) {
			if (kosikContainer) {
				kosikContainer.innerHTML = data;
			}
			updateKosikInfo();
		})
		.catch(function (error) {
			console.log(error);
			addToToastQueue('Chyba při odebrání z košíku', 'Nepodařilo se odebrat zboží z košíku', 'danger');
			setTimeout(function () {
				location.reload();
			}, 5000);
		});
	if (reload)
		setTimeout(function () {
			location.reload();
		}, 5000);



	return false;
}

function oblibenePridat(kC) {

	const url = '/index.php?io=addToFavourites;tName=indexclear;kat_cislo=' + kC;
	const elmAdd = document.getElementById('oblibenePridat-' + kC);
	const elmRemove = document.getElementById('oblibeneOdebrat-' + kC);
	fetch(url)
		.then(function (response) {
			if (response.status === 200) {
				addToToastQueue('Oblíbené položky', 'Zboží zařazeno mezi oblíbené', 'success');
				elmAdd && elmAdd.classList.add('old');
				elmRemove && elmRemove.classList.remove('old');
			} else {
				addToToastQueue('Chyba při zařazení do oblíbených', 'Nepodařilo se zařadit zboží mezi oblíbené', 'danger');
				console.log(response.statusText);
			}
		})
		.catch(function (error) {
			console.log(error);
			addToToastQueue('Chyba při zařazení do oblíbených', 'Nepodařilo se zařadit zboží mezi oblíbené', 'danger');
		})

	return false;
}

function oblibeneOdebrat(kC, refresh) {
	const elmAdd = document.getElementById('oblibenePridat-' + kC);
	const elmRemove = document.getElementById('oblibeneOdebrat-' + kC);
	const url = '/index.php?io=addToFavourites;tName=indexclear;kat_cislo=' + kC + ';delete=1';
	if (refresh == 1) {
		window.location.replace(url);
	} else {
		fetch(url)
			.then(function (response) {
				if (response.status === 200) {
					addToToastQueue('Oblíbené položky', 'Zboží odebráno z oblíbených', 'success');
					elmAdd && elmAdd.classList.remove('old');
					elmRemove && elmRemove.classList.add('old');
				} else {
					addToToastQueue('Chyba při odebrání z oblíbených', 'Nepodařilo se odebrat zboží z oblíbených', 'danger');
					console.log(response.statusText);
				}
			})
			.catch(function (error) {
				console.log(error);
				addToToastQueue('Chyba při odebrání z oblíbených', 'Nepodařilo se odebrat zboží z oblíbených', 'danger');
			})
		return false;
	}
}

function imgDetail(imgPath) {
	// Vytvoření nového elementu pro plnou velikost fotky
	const modal = document.createElement('div');
	modal.classList.add('modal');
	modal.innerHTML = '<div class="modal-dialog modal-lg">' +
		'  <div class="modal-content">' +
		'    <div class="modal-header">' +
		'      <h5 class="modal-title">Plná velikost fotky</h5>' +
		'      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
		'    </div>' +
		'    <div class="modal-body">' +
		'      <img src="' + imgPath + '" alt="Plná velikost fotky" class="img-fluid">' +
		'    </div>' +
		'  </div>' +
		'</div>';

	// Přidání modálního okna do těla dokumentu
	document.body.appendChild(modal);

	// Zobrazení modálního okna
	const myModal = new bootstrap.Modal(modal);
	myModal.show();

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape' && myModal._isShown) {
			myModal.hide(); // Uzavření modálního okna
		}
	});

	// Odstranění modálního okna po zavření
	modal.addEventListener('hidden.bs.modal', function () {
		document.body.removeChild(modal);
	});
}

function updateKosikInfo() {
	const url = "aio/kosik-info";

	fetch(url)
		.then(response => {
			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			return response.json();
		})
		.then(data => {
			// Získání všech elementů uvnitř #kosik-info s atributem data-ajax-key
			const elements = document.querySelectorAll('#kosik-info [data-ajax-key]');
			elements.forEach(element => {
				// Získání hodnoty data-ajax-key
				const ajaxKey = element.getAttribute('data-ajax-key');
				// Aktualizace obsahu elementu podle odpovídající hodnoty v JSON datu
				var number = data[ajaxKey] || 0
				element.textContent = number.toLocaleString('cs-CZ', {minimumFractionDigits: 2, maximumFractionDigits: 2});
			});

		})
		.catch(error => {
			console.error("There has been a problem with your fetch operation:", error);
		});


}

function addToToastQueue(title, message, type) {
	const toastContainer = document.getElementById('toast-container');
	const toast = document.createElement('div');
	toast.className = 'toast';
	toast.setAttribute('role', 'alert');
	toast.setAttribute('aria-live', 'assertive');
	toast.setAttribute('aria-atomic', 'true');
	toast.setAttribute('data-bs-delay', '10000');
	toast.setAttribute('data-bs-autohide', 'true');
	const toastContent = `
        <div class="toast-header">
            <strong class="me-auto">${title}</strong>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body">
            ${message}
        </div>
    `;

	toast.innerHTML = toastContent;
	toast.classList.add(`bg-${type}`);

	toastContainer.appendChild(toast);

	const toastInstance = new bootstrap.Toast(toast);
	toastInstance.show();

	setTimeout(() => {
		toastInstance.hide();
		toast.remove();
	}, 60000);
}

function changeNchDivision(nchDivision) {
	var today = new Date();
	var expire = new Date();

	expire.setTime(today.getTime() + 3600000 * 24 * -1);
	document.cookie = "nchdivision" + "=;expires=" + expire.toGMTString();

	expire.setTime(today.getTime() + 3600000 * 24 * 100000);
	document.cookie = "nchdivision" + "=" + escape(nchDivision) + ";expires=" + expire.toGMTString() + "; path=/";

	window.location.replace("/online");
}


function changeOrderItem(polId, orderId) {
	var mnozstvi = document.getElementById('polZmenForm' + polId).value;
	window.location.replace('/index.php?io=objPolZmen&id_objio=' + orderId + '&id_objio_pol=' + polId + '&mnozstvi=' + mnozstvi);
}

function checkEnter(e, polId, orderId) {
	var keynum;
	var keychar;

	if (window.event) {
		// IE
		keynum = e.keyCode
	} else if (e.which) {
		// Netscape/Firefox/Opera
		keynum = e.which
	}

	if (keynum == 13) {
		changeOrderItem(polId, orderId);
		return false;
	}
}

var activeNahled = null;

function switchKalendarNahled(elem) {
	var mainNahled = document.getElementById('mainNahled');
	if (mainNahled != undefined) {
		mainNahled.src = elem.src;
		elem.className = "active";
		if (activeNahled != null) {
			activeNahled.className = null;
		}
		activeNahled = elem;
	}
}

function kontrolaMaximalniVyseBudgetu(msg, elem) {

	if ($('#castka').val() == '') {
		alert(hlaseniNoBudget);
		return false;
	}

	return true;
}

function zobrazHlaseni(zprava) {
	var target = $('.qtip.jgrowl:visible:last');

	$('<div/>').qtip({
		content: {
			text: zprava,
			title: {
				button: true
			}
		},
		position: {
			target: [0, 0],
			container: $('#qtip-growl-container')
		},
		show: {
			event: false,
			ready: true,
			effect: function () {
				$(this).stop(0, 1).animate({height: 'toggle'}, 400, 'swing');
			},
			delay: 0,
			persistent: false
		},
		hide: {
			event: false,
			effect: function (api) {
				$(this).stop(0, 1).animate({height: 'toggle'}, 1000, 'swing');
			}
		},
		style: {
			width: 200,
			classes: 'jgrowl',
			tip: false
		},
		events: {
			render: function (event, api) {
				if (!api.options.show.persistent) {
					$(this).bind('mouseover mouseout', function (e) {
						var lifespan = 3000;

						clearTimeout(api.timer);
						if (e.type !== 'mouseover') {
							api.timer = setTimeout(function () {
								api.hide(e)
							}, lifespan);
						}
					})
						.triggerHandler('mouseout');
				}
			}
		}
	});
}


function zkontrolujOtazku(elem, otazka, maxPocet) {
	var pocet = $('.ot' + otazka + ':checked').length;
	if (pocet > maxPocet) {
		alert('Maximální množství možných odpovědí, které je možné zvolit u této otázky je ' + maxPocet);
		return false;
	} else {
		return true;
	}
}

function zkontrolujOtazkuMultiSelect(elem, otazka, maxPocet) {
	var $sb = $(elem);
	var pocet = $sb.find(':selected').length;
	if (pocet > maxPocet) {
		$sb.find(':selected').prop('selected', null);
		alert('Maximální množství možných odpovědí, které je možné zvolit u této otázce je ' + maxPocet);
		return false;
	} else {
		return true;
	}
}

function overIcoAres(ico) {
	isSendingIC = true;
	icHlaska = true;
	$('#hlaseni-ares').removeClass('old');

	$.ajax({
		url: "/ares.php",
		contentType: "application/json; charset=utf-8",
		dataType: "json",
		data: "ico=" + ico,
		cache: false,
		success: function (data) {
			if (data.stav == 'ok') {
				$('input[name=ic]').val(data.ico);
				$('input[name=dic]').val(data.dic);
				$('input[name=jmeno]').val(data.firma);
				$('input[name=ulice]').val(data.ulice);
				$('input[name=mesto]').val(data.mesto);
				$('input[name=psc]').val(data.psc);
			} else {
				if (icHlaska) {
					alert(data.stav);
				}
				icHlaska = false;
				vymazFormular();
			}
			isSendingIC = false;
		},
		error: function (jqXHR, textStatus, errorThrown) {
			// vyskytla se chyba
			vymazFormular();
		}
	});

	window.setTimeout(function () {
		$('#hlaseni-ares').addClass('old');
	}, 1000);

}

function vymazFormular() {
	$('input[name=ic]').val('');
	$('input[name=dic]').val('');
	$('input[name=jmeno]').val('');
	$('input[name=ulice]').val('');
	$('input[name=mesto]').val('');
	$('input[name=psc]').val('');
}
